import { render, staticRenderFns } from "./dealermodule.vue?vue&type=template&id=fbcbcebc&"
import script from "./dealermodule.vue?vue&type=script&lang=js&"
export * from "./dealermodule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports